/**
 * If re-open a voyage, this voyage will have a sequence number in Wels. If not, this is the current voyage and shows "Current".
 * Also updates production environment if in dev/QA/etc
 * TODO: After the change in start/end voyages. Why does why not give a number to new voyages?
 */

var VRC = VRC || {};

VRC.VoyageNoView = (function(){


  var update = function(voyageNo){
      voyageNo = voyageNo ? '#' + voyageNo : 'Current';

      $(".voyage_no span").text(voyageNo);
  };

  var updateEnvironment = function(environment){
    var $env = $(".environment");
    if(environment || environment !== 'prod'){
      environment = environment.substr(0,1).toUpperCase() + environment.substr(1);
      $env.text('Server: ' + environment);
      $env.delay( 1000 ).fadeTo('slow', 0.0).fadeTo('slow', 1.0);
    }

  };

  return {
    update : update,
    updateEnvironment : updateEnvironment
  }
})();
